import { create } from "zustand";

interface Role {
	id: number;
	name: string;
	permissions: number[];
}

type SystemRole = Role | null;

interface SystemRoleState {
	systemRoleToDelete: SystemRole;
	systemRoleToEdit: SystemRole;
	isDeleteModalOpen: boolean;
	isEditModalOpen: boolean;
	setSystemRoleToDelete: (role: SystemRole) => void;
	setSystemRoleToEdit: (role: SystemRole) => void;
	setIsDeleteModalOpen: (isOpen: boolean) => void;
	setIsEditModalOpen: (isOpen: boolean) => void;
}

export const useSystemRoleStore = create<SystemRoleState>((set) => ({
	systemRoleToDelete: null,
	systemRoleToEdit: null,
	isDeleteModalOpen: false,
	isEditModalOpen: false,
	setSystemRoleToDelete: (role) => set({ systemRoleToDelete: role }),
	setSystemRoleToEdit: (role) => set({ systemRoleToEdit: role }),
	setIsDeleteModalOpen: (isOpen) => set({ isDeleteModalOpen: isOpen }),
	setIsEditModalOpen: (isOpen) => set({ isEditModalOpen: isOpen })
}));
